import type { JSX } from 'react';

import { useTestingCenterContext } from './TestingCenterLayout';
import CasesSection from './cases/CasesSection';

const TestingCenterCasesPage = (): JSX.Element => {
  const { masterProject, subProjects } = useTestingCenterContext();

  return <CasesSection key={masterProject.id} masterProject={masterProject} subProjects={subProjects} />;
};

export default TestingCenterCasesPage;
